// extracted by mini-css-extract-plugin
module.exports = {"content":"Tabs_content__3KWhA","hidden":"Tabs_hidden__MCGRb"};